import Id from './Id';
import CreatorUser from './CreatorUser';
import Product from './Product';
import Supplier from './Supplier';
import ExpirationDate from './ExpirationDate';
import From from './From';
import To from './To';
import Created from './Created';

export const labels = {
  Id: 'Id',
  CreatorUser: 'Rögzítette',
  Product: 'Termék',
  Supplier: 'Beszállító',
  ExpirationDate: 'Szav. idő',
  From: 'Kezdeti készlet',
  To: 'Záró készlet',
  Created: 'Létrehozva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'CreatorUser',
}, {
  value: 'Product'
},{
  value: 'Supplier'
}, {
  value: 'ExpirationDate'
}, {
  value: 'From'
}, {
  value: 'To'
}, {
  value: 'Created',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'CreatorUser',
}, {
  value: 'Product'
},{
  value: 'Supplier'
}, {
  value: 'ExpirationDate'
}, {
  value: 'From'
}, {
  value: 'To'
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Id.propName,
  order: 'ascending'
};

export default {
  Id,
  CreatorUser,
  Product,
  Supplier,
  ExpirationDate,
  From,
  To,
  Created
};
